type PageTab = {
  id: string;
  label: string;
};

export default function PageTabs({
  tabs,
  activeTab,
  onChange,
}: {
  tabs: PageTab[];
  activeTab: string;
  onChange: (tabId: string) => void;
}) {
  return (
    <div className="border-b border-gray-200">
      <div className="flex flex-wrap gap-x-6">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onChange(tab.id)}
              className={[
                "relative py-3 text-sm font-semibold transition-colors",
                isActive
                  ? "text-[#6941C6]"
                  : "text-gray-500 hover:text-gray-700",
              ].join(" ")}
            >
              {tab.label}
              {isActive && (
                <span className="absolute inset-x-0 bottom-0 h-0.5 rounded-full bg-[#7F56D9]" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
